const hooks = {};
function setupHooks(next) {
  Object.assign(hooks, next);
}
export {
  hooks,
  setupHooks
};
